import { PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  payment_methods: {
    [PaymentMethod.Card]: 'Luottokortti',
    [PaymentMethod.Sofort]: 'Sofort',
    [PaymentMethod.Giropay]: 'Giropay',
    [PaymentMethod.PayByBank]: 'Maksa pankilla',
    [PaymentMethod.SepaDebit]: 'EC-kortti / IBAN',
    [PaymentMethod.Cash]: 'Käteinen',
    [PaymentMethod.Link]: 'Link',
    [PaymentMethod.StripeOther]: 'Muu maksutapa',
  },
};
